// extracted by mini-css-extract-plugin
export default {"head":"freeAnswer_head__i-Auy","main":"freeAnswer_main__JlRQQ"};